<template>
    <div class="add-line" v-bind:class="{active: displayButtons}" @mouseleave="hideButtonsWithTimeout" @mouseenter="cancelTimeout">
        <div class="add-line-container" @click="showButtons">
            <i class="fas fa-plus-square"></i>
            <hr />
        </div>
        <div class="add-line-buttons pnl-row" v-if="displayButtons">
            <button @click="addCondition()">Add Condition</button>
            <button @click="addAction()">Add Action</button>
            <button class="b-cancel" @click="hideButtons()">Cancel</button>
        </div>
    </div>
</template>

<script>
export default {
	name: "AddLine",
	data: () => ({displayButtons: false, cTimeout: null}),
	created() {
		this.$root.$on("add-line-close", (item) => {
			if (item !== this) {
				this.displayButtons = false;
			}
		});
	},
	methods: {
		showButtons() {
			this.displayButtons = true;
			this.$root.$emit("add-line-close", this);
		},
		hideButtons() {
			this.displayButtons = false;
		},
		hideButtonsWithTimeout() {
			// this.cTimeout = setTimeout(() => this.hideButtons(), 500);
		},
		cancelTimeout() {
			clearTimeout(this.cTimeout);
		},
		addCondition() {
			this.$emit("add-condition");
			this.displayButtons = false;
		},
		addAction() {
			this.$emit("add-action");
			this.displayButtons = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.add-line {
    position:relative;
    hr{
        flex:1; border-top:2px solid red; margin: 0;
    }
    &-container {
		display:flex; align-items:center; font-size:15pt; cursor:pointer; margin:-8px -10px -8px -16px; opacity:0;
		transition: margin-left ease 1s;
		&:hover {
			opacity:1;
        }
		.active & {
			opacity:1; margin-left: -25px; cursor: inherit;
			i {background-color: white; border-radius:5px;}
        }
    }
    &-buttons {
		margin-top:-9px; //background-color: red; border:1px solid red;
		border-top: none transparent;
		border-top-left-radius:0; border-top-right-radius:0;
		button {
			background-color:white; border:0; border-radius:2px; margin-right: 5px;
		}
		display:flex;
		.b-cancel{align-self:end; margin-left:auto;}
        // position:absolute; top:0; left:0; width: 100%;
    }
}
</style>
